import AppBar from "@material-ui/core/AppBar";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import React from "react";
import logo from "../logo.svg";
import { isToolbarEnabled, showTitleInMobileMode } from "../components/AppConfig";

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    backgroundColor: "#f9aa33"
  },
  menuButton: {
    marginRight: theme.spacing(2)
  },
  signOutButton: {
    textTransform: "none",
    backgroundColor: "#344955",
    // color: "#f9aa33",
    color: "#fff",
    flex: 1,
    "&:hover": {
      backgroundColor: "#344955"
    }
  },
  betaButton: {
    marginLeft: theme.spacing(1),
    padding: theme.spacing(0.5),
    borderRadius: 5,
    fontSize: 11,
    backgroundColor: "#344955",
    color: "#f9aa33"
    // color: "#fff",
  },
  title: {
    fontWeight: "bold",
    color: "#344955",
    marginLeft: theme.spacing(0.5)
  },
  name: {
    textAlign: "right",
    flex: 1,
    fontWeight: "bold",
    marginRight: theme.spacing(2),
    color: "#344955"
  }
}));

export default function ButtonAppBar(props) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      {isToolbarEnabled === true ? (
        <AppBar position="relative" className={classes.root}>
          <Toolbar>
            <img src={logo} className="App-logo" alt="logo" />
            {window.innerWidth > 500 || showTitleInMobileMode ? <Typography className={classes.title}>CloudPass</Typography> : null}
            <Typography className={classes.betaButton} styles={{ color: "#344955" }}>
              BETA
            </Typography>
            <Typography className={classes.name} color="inherit">
              {props.user !== undefined && props.user !== null ? props.user.displayName : ""}
            </Typography>
            {props.user ? (
              <div>
                <Button
                  variant="contained"
                  className={classes.signOutButton}
                  onClick={() => {
                    props.logout();
                    props.signOut();
                  }}
                >
                  Sign out
                </Button>
              </div>
            ) : null}
          </Toolbar>
        </AppBar>
      ) : null}
    </div>
  );
}
